import React, { useEffect } from "react";
import DashboardAlerts from "@system/config/dashboard-alerts";
import { useSearchParams } from 'react-router-dom';
import useReduxState from 'src/hooks/useReduxState';
import { useAlertStore } from 'src/hooks/Alert';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import PCNTabContent from './PCNAlert/PCNTabContent';
import EOLTabContent from './EOLAlert/EOLTabContent';
import Constants from 'src/support/Constants';
import StockAlertTabContent from "./StockAlert/StockAlertTabContent";
const param_key_AlertTabList = '__c_ALertTabList';
const redux_key_AlertTabList = 'AlertTabList__Component__Loader';

const AlertTabListing = () => {
    const { defaultAlertTabList, alertTypes: { PCN, EOL, STOCK_ALERT } } = Constants
    const default_component_AlertTabList = defaultAlertTabList.PCN;
    const [__check] = useAxiosIndicatorCheck();
    const alertType = System.getParams().__c_ALertTabList
    const [selectedTab, setSelectedTab] = useReduxState(PCN, 'searchParams')
    const [searchParams] = useSearchParams();
    const [AlertTabList__Component__Loader, Set_AlertTabList__Component__Loader] = useReduxState(searchParams.get(param_key_AlertTabList) ? searchParams.get(param_key_AlertTabList) : default_component_AlertTabList.name, redux_key_AlertTabList, 'AlertTabList__Component__Loader');
    const [{ alertTabsCount }, { get_alert_count }] = useAlertStore();
    const [AlertFirstServerCall, setAlertFirstServerCall] = useReduxState(false, 'setAlertFirstServerCall');
    const getActiveClass = (singleElement) => {
        if (defaultAlertTabList[AlertTabList__Component__Loader].name === singleElement.name) {
            return 'active'
        }
        return ''
    };
    const getTabLink = (singleElement) => {
        return DashboardAlerts.getAlertTabsListRouteURL({
            [param_key_AlertTabList]: singleElement.alias
        });
    };
    const switchTab = async (url, chain_single) => {
        if (AlertFirstServerCall) {
            setAlertFirstServerCall(false);
        }
        history.pushState('', '', url);
        Set_AlertTabList__Component__Loader(chain_single.alias);
    };

    useEffect(() => {
        async function fetchHere() {
            if (selectedTab) {
                await get_alert_count(selectedTab)
            }
            setAlertFirstServerCall(true);
        }
        fetchHere();
    }, [selectedTab]);

    useEffect(() => {
        async function fetchHere() {
            setSelectedTab(alertType !== undefined ? alertType : PCN)
        }

        fetchHere()
    }, [alertType,]);

    return (
        <>
            <div className="mobile-tab pcn-eol-tabs">
                <ul className="bs5 nav nav-tabs">
                    {Object.entries(defaultAlertTabList).map((v) => (
                        <React.Fragment key={v[1].alias}>
                            <li key={v[1].alias}>
                                <a className={'text-uppercase font-bold ' + getActiveClass(v[1])}
                                    href={void (0)}
                                    onClick={async () => {
                                        await switchTab(getTabLink(v[1]), v[1])
                                    }}
                                >
                                    <span>{v[1].name} {v[1].alias === PCN &&
                                        !__check(['ALERT_API_CALL']).status && (alertTabsCount?.PCNCount >= 0) && '(' + alertTabsCount.PCNCount + ')'}
                                        {v[1].alias === EOL && !__check(['EOL_ALERT_API_CALL']).status && (alertTabsCount?.EOLCount >= 0) && '(' + alertTabsCount.EOLCount + ')'}</span>
                                    {v[1].alias === STOCK_ALERT && !__check(['STOCK_ALERT_API_CALL']).status && (alertTabsCount?.StockCount >= 0) && '(' + alertTabsCount.StockCount + ')'}
                                </a>
                            </li>
                        </React.Fragment>
                    ))
                    }
                </ul>

            </div>
            <div className="tab-content px-3">

                <div
                    id={selectedTab}
                    className="tab-pane active table-container">
                    {selectedTab === defaultAlertTabList.PCN.alias && <PCNTabContent />}
                    {selectedTab === defaultAlertTabList.EOL.alias && <EOLTabContent />}
                    {selectedTab === defaultAlertTabList.Stock.alias && <StockAlertTabContent />}
                </div>
            </div>

        </>
    );
}

export default AlertTabListing;